export const keyboardEvents = {
  Enter: 'Enter',
  Escape: 'Escape',
  Space: ' ',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  Tab: 'Tab'
};
export const withKeyboardAccessibility = function (handler, handlerKeyList) {
  if (handlerKeyList === void 0) {
    handlerKeyList = [keyboardEvents.Enter, keyboardEvents.Space];
  }
  return e => {
    if (Array.isArray(handlerKeyList) && handlerKeyList.includes(e.key)) {
      handler(e);
    }
  };
};

/* default utilities  */
export default {
  keyboardEvents,
  withKeyboardAccessibility
};